import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FieldArrayComponent } from 'components/_basic/Form/FieldArray';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { KeyEventsRow } from './components/KeyEventsRow';
import { ABOUT_COMPANY_HISTORY_NAMES, listOfKeyEventsInitialValues, prefix } from './utils/form';

export const CompanyHistory: FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.ABOUT_COMPANY,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_ABOUT_COMPANY.COMPANY_HISTORY,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('company.title')}
          badgeText={t('company.history.title')}
          section={FOR_BANK_SECTIONS.ABOUT_COMPANY}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('company.history.businessIdeaConception')}
        aiFieldName={concatWithDot(prefix, ABOUT_COMPANY_HISTORY_NAMES.BUSINESS_IDEA_CONCEPTION)}
      >
        <TextInputControl
          multiline
          control={control}
          id="company.history.businessIdeaConception"
          name={concatWithDot(prefix, ABOUT_COMPANY_HISTORY_NAMES.BUSINESS_IDEA_CONCEPTION)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('company.history.motivation')}
        aiFieldName={concatWithDot(prefix, ABOUT_COMPANY_HISTORY_NAMES.MOTIVATION)}
      >
        <TextInputControl
          multiline
          control={control}
          id="company.history.motivation"
          name={concatWithDot(prefix, ABOUT_COMPANY_HISTORY_NAMES.MOTIVATION)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('company.history.events')}
        // aiFieldName={concatWithDot(prefix, ABOUT_COMPANY_HISTORY_NAMES.EVENTS)}
        // aiFieldType="complex"
        collapsible
      >
        <FieldArrayComponent
          name={concatWithDot(prefix, ABOUT_COMPANY_HISTORY_NAMES.EVENTS)}
          initialItem={listOfKeyEventsInitialValues}
          buttonText={t('keyEvent')}
          disabled={!canAccess}
        >
          {(namePrefix) => <KeyEventsRow multiline maxLength={500} hiddenLabel name={namePrefix} disabled={!canAccess} />}
        </FieldArrayComponent>
      </FormSectionCard>
    </>
  );
};
